import React from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import { injectIntl, FormattedMessage } from 'react-intl';

import H1 from 'shared/app/components/h1';
import HeaderCrateWithLogo from 'shared/app/components/header-crate-with-logo';
import { routeSelector } from 'shared/app/state/selectors/routes';

import messages from './messages';

const mapRouteToTitleMessage = {
  '/account/reset-password-success': 'resetPasswordSuccessTitle',
  '/account/reset-password/:token': 'resetPasswordTitle',
};

const ResetPasswordHeader = ({ intl: { formatMessage }, route }) => (
  <HeaderCrateWithLogo>
    <Helmet title={formatMessage(messages[mapRouteToTitleMessage[route]])} />

    <H1 className="text-bold" size="lg">
      <FormattedMessage {...messages.resetPasswordHeading} />
    </H1>
  </HeaderCrateWithLogo>
);

ResetPasswordHeader.displayName = ResetPasswordHeader;

const select = (state) => ({
  route: routeSelector(state),
});

export default injectIntl(connect(select)(ResetPasswordHeader));
